import { Backdrop, Box, CircularProgress, Grid, Stack } from '@mui/material';
import { useState } from 'react';

import { useContractDetails } from '../../../services/contractDetails';
import { BaseController } from '../../BaseController/baseController';
import { ButtonContent } from '../buttonContent/buttonContent';
import { ContractData } from '../contractData/contractData';
import { ProductImage } from '../productImage/productImage';
import { AdjustEquipmentForm } from './adjustEquipmentForm/adjustEquipmentForm';

export interface AdjustEquipmentContentProps {
  contractNumber: string;
  contractPosition: string;
}

export const AdjustEquipmentContent = (props: AdjustEquipmentContentProps) => {
  const { contractNumber, contractPosition } = props;

  const { contractDetails, isLoading } = useContractDetails({
    contractNumber,
    contractPosition,
  });

  const [showBusy, setShowBusy] = useState(false);

  if (isLoading || showBusy) {
    return (
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading || showBusy}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Grid container sx={{ maxWidth: '1200px', alignItems: 'center' }}>
        <Stack direction="row" justifyContent="flex-end" width="100%">
          <Stack
            width="100%"
            direction="column"
            alignItems="flex-start"
            style={{ marginTop: '30px', marginBottom: '30px' }}
            spacing={4}
          >
            <ButtonContent
              contractDetail={BaseController.mapResponseContractToInternalContractDetail(
                contractDetails.equipment,
              )}
              buttonGroup="returnEquipment"
            />
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              width="100%"
              spacing={2}
            >
              <ProductImage
                serialNumber={
                  BaseController.mapResponseContractToInternalContractDetail(
                    contractDetails.equipment,
                  ).equipmentSerialNr
                }
              />
              <ContractData
                contractDetails={BaseController.mapResponseContractToInternalContractDetail(
                  contractDetails.equipment,
                )}
              />
            </Stack>
            <AdjustEquipmentForm
              currentEquipment={BaseController.mapResponseContractToInternalContractDetail(
                contractDetails.equipment,
              )}
              setShowBusy={setShowBusy}
            />
          </Stack>
        </Stack>
      </Grid>
    </Box>
  );
};
